import { render, staticRenderFns } from "./AddBillingItems.vue?vue&type=template&id=31659458&"
import script from "./AddBillingItems.vue?vue&type=script&lang=js&"
export * from "./AddBillingItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports